import { SanctionsListRuleSource } from "~/templates/rulesEditor/types";

export interface SelectOption {
  label: string;
  value: string;
  isDisabled?: boolean;
}

export const ACTION_RULES = [
  {
    label: "Approve/Accept",
    value: "APPROVE",
  },
  {
    label: "Cancel/Reject",
    value: "REJECT",
  },
  {
    label: "Send to inbox (for manual review)",
    value: "SEND_TO_INBOX",
  },
];

export const RULE_CHECK = [
  {
    label: "Vasp",
    value: "VASP",
  },
  {
    label: "Jurisdiction",
    value: "JURISDICTION",
  },
  {
    label: "Risk Score",
    value: "RISK_SCORE",
  },
  {
    label: "Sanction List Check",
    value: "SANCTION_LIST_CHECK",
  },
];

export const RISK_SCORE_SOURCE: SelectOption[] = [
  {
    label: "Chainalysis v1",
    value: "CHAINALYSIS",
  },
  {
    label: "Chainalysis v2",
    value: "CHAINALYSIS2",
  },
  {
    label: "Elliptic",
    value: "ELLIPTIC",
  },
  {
    label: "TRM",
    value: "TRM",
  },
  {
    label: "Coinfirm",
    value: "COINFIRM",
  },
  {
    label: "Crystal",
    value: "CRYSTAL",
  },
  {
    label: "Merkle Science",
    value: "MERKLESCIENCE",
  },
];

export const RISK_SCORE_CHAINALYSIS2_VALUE = [
  {
    label: "Severe",
    value: "SEVERE",
  },
  {
    label: "High",
    value: "HIGH",
  },
  {
    label: "Medium",
    value: "MEDIUM",
  },
  {
    label: "Low",
    value: "LOW",
  },
  {
    label: "No alerts available",
    value: "NO_ALERTS_AVAILABLE",
  },
];

// 0-100
export const RISK_SCORE_COINFIRM_VALUE = [
  {
    label: "66-99 - High Risk",
    value: "99",
  },
  {
    label: "33-65 - Medium Risk",
    value: "65",
  },
  {
    label: "0-32 - Low Risk",
    value: "32",
  },
];

// 0%-100%
export const RISK_SCORE_CRYSTAL_VALUE = [
  {
    label: "75%-100% - High Risk",
    value: "1",
  },
  {
    label: "26%-74% - Medium Risk",
    value: ".74",
  },
  {
    label: "0%-25% - Low Risk",
    value: ".25",
  },
];

export const SANCTION_LIST_CHECK_SOURCE: SelectOption[] = [
  {
    label: "Refinitiv",
    value: SanctionsListRuleSource.REFINITIV,
  },
  {
    label: "Comply Advantage",
    value: SanctionsListRuleSource.COMPLY_ADVANTAGE,
  },
  {
    label: "TRM Sanctions Screening",
    value: SanctionsListRuleSource.TRM_SANCTIONS,
  },
  {
    label: "LexisNexis",
    value: SanctionsListRuleSource.LEXIS_NEXIS,
  },
];

export const RISK_SCORE_CHAINALYSIS_VALUE = [
  {
    label: "High",
    value: "highRisk",
  },
  {
    label: "Low",
    value: "lowRisk",
  },
  {
    label: "Unknown",
    value: "unknown",
  },
];

export const RISK_SCORE_TRM_VALUE = [
  {
    label: "Severe",
    value: "SEVERE",
  },
  {
    label: "High",
    value: "HIGH",
  },
  {
    label: "Medium",
    value: "MEDIUM",
  },
  {
    label: "Low",
    value: "LOW",
  },
  {
    label: "No/Unknown risk",
    value: "null",
  },
];

export const RISK_SCORE_ELLIPTIC_VALUE = [
  { label: "NULL", value: "-1" },
  { label: "NO INFORMATION AVAILABLE", value: "NO_INFORMATION_AVAILABLE" },
  ...Array.from(Array(11).keys()).map((num) => {
    // 0-10
    return {
      label: num.toString(),
      value: num.toString(),
    };
  }),
];

export const SANCTION_LIST_CHECK_REFINITIV_VALUE = [
  {
    label: "Potential Match",
    value: "true",
  },
  {
    label: "No match",
    value: "false",
  },
];

// 0-5
export const RISK_SCORE_MERKLESCIENCE_VALUE = Array.from(Array(6).keys()).map((num) => {
  return {
    label: ["No Risk Detected", "Info", "Caution", "Medium", "High", "Critical"][num],
    value: num.toString(),
  };
});

export const SANCTION_LIST_CHECK_COMPLY_ADVANTAGE_VALUE = [
  {
    label: "Potential Match",
    value: "true",
  },
  {
    label: "No match",
    value: "false",
  },
];

export const SANCTION_LIST_CHECK_LEXISNEXIS_VALUE = [
  {
    label: "Potential Match",
    value: "true",
  },
  {
    label: "No match",
    value: "false",
  },
];

export const SANCTION_LIST_CHECK_TRM_SANCTIONS_VALUE = [
  {
    label: "Potential Match",
    value: "true",
  },
  {
    label: "No match",
    value: "false",
  },
];

export const REVIEWED_VASP_LIST_VALUES = [
  {
    label: "Blocked VASP",
    value: "BLOCKED",
  },
  {
    label: "Monitored VASP",
    value: "MANUAL",
  },
  {
    label: "Trusted VASP",
    value: "TRUSTED",
  },
  {
    label: "Not Reviewed",
    value: "NULL",
  },
];

export const SELF_HOSTED_WALLET_PROOF_LIST_VALUES = [
  {
    label: "Signature",
    value: "SIGNATURE",
  },
  {
    label: "Checkbox (self-attestation)",
    value: "CHECKBOX",
  },
  {
    label: "Microtransfer",
    value: "MICROTRANSFER",
  },
  {
    label: "Screenshot",
    value: "SCREENSHOT",
  },
  {
    label: "Other",
    value: "OTHER",
  },
  {
    label: "Don't check proof",
    value: "IGNORE",
  },
];

export const RISK_SCORE_SCORECHAIN_VALUE = [
  {
    label: "1 - Critical Risk",
    value: "CRITICAL",
  },
  {
    label: "2-29 - High Risk",
    value: "HIGH",
  },
  {
    label: "30-69 - Medium Risk",
    value: "MEDIUM",
  },
  {
    label: "70-99 - Low Risk",
    value: "LOW",
  },
  {
    label: "100 - No Risk Detected",
    value: "NO_RISK",
  },
];
